var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgMailCredits = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.694 2.44629C22.4445 1.79929 23.5555 1.79929 24.306 2.44629L27.8573 5.50808C28.5974 6.1462 29.5455 6.49129 30.5227 6.47822L35.2113 6.41549C36.202 6.40223 37.0531 7.1164 37.2121 8.09439L37.9645 12.7226C38.1213 13.6872 38.6258 14.561 39.3827 15.1791L43.0147 18.1448C43.7822 18.7715 43.9751 19.8656 43.4682 20.717L41.0696 24.746C40.5697 25.5857 40.3945 26.5794 40.5771 27.5394L41.453 32.1459C41.6381 33.1193 41.0826 34.0814 40.1471 34.4078L35.7198 35.9525C34.7971 36.2744 34.0242 36.923 33.5469 37.7757L31.257 41.8675C30.7731 42.7322 29.729 43.1121 28.8026 42.7608L24.4182 41.0983C23.5045 40.7518 22.4955 40.7518 21.5818 41.0983L17.1974 42.7608C16.2709 43.1121 15.2269 42.7322 14.743 41.8675L12.4531 37.7757C11.9758 36.923 11.2029 36.2744 10.2802 35.9525L5.85294 34.4078C4.91741 34.0814 4.36189 33.1193 4.54698 32.1459L5.42292 27.5394C5.60547 26.5794 5.43027 25.5857 4.93037 24.746L2.53177 20.717C2.02491 19.8656 2.21784 18.7715 2.98532 18.1448L2.369 17.39L2.98532 18.1448L6.61728 15.1791C7.37423 14.561 7.87872 13.6872 8.03552 12.7226L8.78791 8.09439C8.9469 7.11639 9.798 6.40223 10.7887 6.41549L15.4773 6.47822C16.4545 6.49129 17.4026 6.1462 18.1427 5.50808L21.694 2.44629Z",
    stroke: "#1D2026",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18.5556C15 18.0841 15.1873 17.6319 15.5207 17.2985C15.8541 16.9651 16.3063 16.7778 16.7778 16.7778H29.2222C29.6937 16.7778 30.1459 16.9651 30.4793 17.2985C30.8127 17.6319 31 18.0841 31 18.5556V27.4445C31 27.916 30.8127 28.3682 30.4793 28.7016C30.1459 29.035 29.6937 29.2223 29.2222 29.2223H16.7778C16.3063 29.2223 15.8541 29.035 15.5207 28.7016C15.1873 28.3682 15 27.916 15 27.4445V18.5556Z",
    stroke: "#3953FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18.5557L23 23.889L31 18.5557",
    stroke: "#3953FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMailCredits, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mailCredits.5c3bf796.svg";
export { ForwardRef as ReactComponent };